import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FAQMessages } from './FAQ.messages';
import { faqEntries } from './faqEntries';

export const FAQ: React.FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  /*
   * Shared with the FAQPage structured data on the homepage, so the markup and the
   * page cannot say different things. First entry is open by default: the objection
   * every developer raises before any of the others is worth answering.
   */
  const faqs = faqEntries(t);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <div className="section-header">
          <h2>{t(FAQMessages.TITLE)}</h2>
          <p className="section-subtitle">
            {t(FAQMessages.SUBTITLE)}
          </p>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="question-text">{faq.question}</span>
                <span className="question-icon" aria-hidden="true">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              
              <div
                id={`faq-answer-${index}`}
                className={`faq-answer ${openIndex === index ? 'open' : ''}`}
                aria-hidden={openIndex !== index}
              >
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-cta">
          <h3>{t(FAQMessages.STILL_HAVE_QUESTIONS)}</h3>
          <p>
            {t(FAQMessages.STILL_HAVE_QUESTIONS_DESC)}
          </p>
          <div className="contact-options">
            <a href="/contact" className="btn btn-secondary">
              {t(FAQMessages.BTN_CONTACT_SUPPORT)}
            </a>
            <a href="/docs" className="btn btn-outline">
              {t(FAQMessages.BTN_VIEW_DOCS)}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
